import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25804594"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title1" }
const _hoisted_2 = { class: "container" }

import store from "@/store";
import { ref, computed } from "vue";
import MobileTab1 from "./MobileTab1.vue";
import MobileTab2 from "./MobileTab2.vue";
import MobileTab3 from "./MobileTab3.vue";
import MobileTab4 from "./MobileTab4.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileTabs',
  setup(__props) {

const activeName = ref("tab1");
const language = computed(() => store.state.appLanguage);
const handleClick = () => {};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("home.core_funs")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MobileTab1),
      _createVNode(MobileTab2),
      _createVNode(MobileTab3),
      _createVNode(MobileTab4)
    ])
  ], 64))
}
}

})